/* ==========================================================================
   HYAKU-PA — Custom JS
   Eingebunden in theme.liquid vor </body>:
   <script src="{{ 'custom.js' | asset_url }}" defer></script>

   1) Logo schrumpft im Header beim Scrollen
   2) Anker fuer die Groessenauswahl
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  /* ------------------------------------------------------------------------
     1) Logo schrumpft im Header beim Scrollen
        Ab 50 px Scrollhoehe bekommt der Logo-Wrapper die Klasse .shrink,
        das Aussehen macht das Custom-CSS-Feld der Header-Section.

        Nur oberhalb 767 px: Auf dem Mobil ist das Logo von Anfang an
        klein, dort gibt es nichts zu schrumpfen. Die 767 weichen vom
        Theme-Umbruch bei 750 ab — bewusst so belassen, weil sie im
        Header-CSS-Feld ebenfalls stehen. Wer sie aendert, muss beide
        Stellen anfassen.

        Der Zustand wird gemerkt, damit classList nur bei einem echten
        Wechsel angefasst wird und nicht bei jedem Scroll-Ereignis.
        passive: true, damit der Browser nicht auf das Skript wartet.
     ---------------------------------------------------------------------- */

  var logoWrapper = document.querySelector('.header__heading-logo-wrapper');

  if (logoWrapper) {
    var geschrumpft = false;

    var pruefen = function () {
      var soll = window.innerWidth > 767 && window.scrollY > 50;
      if (soll === geschrumpft) return;
      geschrumpft = soll;
      logoWrapper.classList.toggle('shrink', soll);
    };

    window.addEventListener('scroll', pruefen, { passive: true });
    window.addEventListener('resize', pruefen, { passive: true });
    pruefen();
  }

  /* ------------------------------------------------------------------------
     2) Anker fuer die Groessenauswahl
        Standard-Sections haben kein Anker-Feld, und die Section-ID enthaelt
        die Template-Nummer, die sich bei jedem Theme-Update aendert.
        Deshalb ueber den stabilen hinteren Teil der ID suchen und davor
        ein leeres Ankerelement einhaengen.

        Ziel ist die Rich-Text-Section mit "FOR THE ROAD OR FOR HOME.",
        damit der Sprung ueber der Ueberschrift landet und nicht
        mitten in den Kreisen. Faellt sie weg, greift ersatzweise die
        Groessen-Multicolumn.

        Verlinkt wird darauf mit /#choose-your-size

        Der Versatz kommt aus scroll-margin-top, nicht aus position/top:
        scroll-margin-top wirkt ausschliesslich beim Anspringen und
        verschiebt nichts im Layout. Die 90 px gleichen den Header aus —
        das ist die einzige Zahl, die nachzujustieren waere.
     ---------------------------------------------------------------------- */

  var ziel = document.querySelector('[id$="__rich_text_DMdaEh"]')
          || document.querySelector('[id$="__multicolumn_VPBjJY"]');

  if (ziel && !document.getElementById('choose-your-size')) {
    var anker = document.createElement('span');
    anker.id = 'choose-your-size';
    anker.style.display = 'block';
    anker.style.scrollMarginTop = '90px';
    ziel.parentNode.insertBefore(anker, ziel);
  }

  /* ------------------------------------------------------------------------
     3) Videos erst laden, wenn sie gebraucht werden
        Sections mit dem Feld "Video erst laden, wenn sichtbar" liefern nur
        das Vorschaubild plus die Videoadresse in data-video. Hier wird das
        video-Element erzeugt, sobald die Section in die Naehe des sichtbaren
        Bereichs kommt (400 px Vorlauf, damit es beim Ankommen schon laeuft).

        Hintergrund: Zwei Videos zu je rund 1,5 MB machten die Haelfte des
        Seitengewichts aus, obwohl das zweite weit unter der Falz liegt.

        Ohne IntersectionObserver (sehr alte Browser) wird sofort geladen —
        dann ist es wie vorher, nur nicht schlechter.
     ---------------------------------------------------------------------- */

  var lazyVideos = document.querySelectorAll('.praktisch__video-lazy[data-video]');

  if (lazyVideos.length) {
    var laden = function (box) {
      if (box.dataset.geladen) return;
      box.dataset.geladen = '1';

      var v = document.createElement('video');
      v.src = box.dataset.video;
      v.autoplay = true;
      v.loop = true;
      v.muted = true;
      v.playsInline = true;
      v.controls = false;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');

      var bild = box.querySelector('img');
      if (bild) v.poster = bild.currentSrc || bild.src;

      v.addEventListener('loadeddata', function () {
        if (bild) bild.style.display = 'none';
      });

      box.appendChild(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };

    if ('IntersectionObserver' in window) {
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          laden(e.target);
          beobachter.unobserve(e.target);
        });
      }, { rootMargin: '400px 0px' });

      Array.prototype.forEach.call(lazyVideos, function (box) {
        beobachter.observe(box);
      });
    } else {
      Array.prototype.forEach.call(lazyVideos, laden);
    }
  }
});
